import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useBranch } from "~/contexts/BranchContext";

const DocumentHeadManager: React.FC = () => {
  const location = useLocation();
  let branch = null;

  // Try to get branch context, but don't fail if not available
  try {
    const branchContext = useBranch();
    branch = branchContext?.branch;
  } catch (error) {
    // BranchContext not available (e.g., on landing page)
    branch = null;
  }

  useEffect(() => {
    if (branch) {
      if (branch.name) {
        document.title = branch.name;
      }

      // Update favicon with branch logo
      if (branch.logo) {
        updateFavicon(branch.logo);
      }
    } else {
      // Default favicon and title for landing page
      updateFavicon("images/Dineai.ico");
      document.title = "Dine.ai";
    }
  }, [branch, location.pathname]);

  const updateFavicon = (logoUrl: string) => {
    // Remove existing favicon links
    const existingFavicons = document.querySelectorAll("link[rel*='icon']");
    existingFavicons.forEach((favicon) => favicon.remove());

    // Create new favicon link
    const link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/png";
    link.href = logoUrl;

    // Add to document head
    document.head.appendChild(link);
  };

  return null;
};

export default DocumentHeadManager;
